import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Button, Form, InputGroup } from 'react-bootstrap';
import { db } from "./use-firebase.js";
import { useRequireAuth } from "./use-require-auth.js";
import { getDocs, collection, updateDoc, query, where, doc } from 'firebase/firestore'; // collection, addDoc, getDocs
import { RESERVED_HANDLES } from "./shared-constants.js";
import Footer from './components/common/Footer.js';
import { ToastContainer, toast, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Onboarding() {

  const auth = useRequireAuth();
  const navigate = useNavigate();
  const [handle, setHandle] = useState(null);
  const [error, setError] = useState(false);
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    if (auth && auth.user) {
      setHandle(auth.user.handle);
    }
  })

  const checkUniqueHandle = async (input_handle) => {
    let response = "hit"
    // reserved words
    if (RESERVED_HANDLES.includes(input_handle)) {
      console.log("reserved");
      return response;
    }
    // check for unique handles
    await getDocs(query(collection(db, "users"), where("handle", "==", input_handle), where("uid", "!=", auth.user.uid))).then((querySnapshot) => {
      // console.log("found", querySnapshot.docs.length);
      if (querySnapshot.docs.length === 0) {
        response = "miss"
      } else {
        response = "hit"
      }
      // console.log("returning", response);
      return response;
    });
  }

  const handleSubmit = (event) => {
    if (event) {
      const form = event.currentTarget;
      event.preventDefault();
      event.stopPropagation();
      if (form.checkValidity() === true) {
        if (RESERVED_HANDLES.includes(handle)) {
          setError(true);
        } else {
          getDocs(query(collection(db, "users"), where("handle", "==", handle), where("uid", "!=", auth.user.uid))).then((querySnapshot) => {
            if (querySnapshot.docs.length === 0) {
              setError(false);
              getDocs(query(collection(db, "users"), where("uid", "==", auth.user.uid))).then((querySnapshot) => {
                querySnapshot.forEach((_doc) => {
                  updateDoc(doc(db, "users", _doc.id), { handle: handle }).then(() => {
                    doToastSuccess("Handle saved!");
                    navigate('/connectwallet');
                  });
                });
              });
            } else {
              setError(true);
            }
          });
        }
      }
      setValidated(true);
    }
  };

  const doToastSuccess = (text) => {
    toast.success(text, {
      position: "top-right",
      theme: "light",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
    })
  };

  const doToastError = (text) => {
    toast.error(text, {
      position: "top-right",
      theme: "light",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
    })
  };

  return (
    <Row style={{ justifyContent: 'center', marginBottom: 40, marginTop: 60 }}>
      <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, minHeight: '60vh' }}>
        <Col xs={12} sm={11} md={11} lg={11} xl={11}>
          <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start', marginLeft: 0, marginRight: 0 }}>
            <h3>Choose your unique handle</h3>
          </Row>
          <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, marginTop: 20, marginBottom: 100 }}>
            <Col xs={12} sm={10} md={8} lg={6} xl={4} style={{ padding: 0 }}>
              <Form onSubmit={handleSubmit} style={{ marginTop: 20 }}>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="handle" style={{ backgroundColor: '#EEEEEE', color: '#111111', borderWidth: 0, borderRadius: 0 }}>moleculeclimate.com/</InputGroup.Text>
                  <Form.Control required as="input" type="text" minLength="3" maxLength="24" value={handle} onChange={(e) => setHandle(e.target.value.replace(/[^a-zA-Z0-9]/g,'').replace(/\s/g, ''))} />
                </InputGroup>
                { error &&
                  <p className="small" style={{ color: 'red', marginTop: -10 }}>Choose a unique handle 3 to 24 characters long</p>
                }
                <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, marginTop: 20 }}>
                  <Button variant="primary" type="submit" style={{ width: '100%' }}>Save</Button>
                </Row>

              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
      <section className="footer-text" style={{ width: '100%', paddingTop: 40, paddingLeft: 30, paddingRight: 30, paddingBottom: 20, textAlign: 'center' }}>
        <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
          <Col style={{ textAlign: 'center' }}>
            <p className="muted small">Copyright 2022 Fanflow Inc.</p>
          </Col>
        </Row>
      </section>
    </Row>
  );

}
